import styled, { createGlobalStyle } from 'styled-components';
import { baseEditorStyles, baseElementStyles, defaultFontFaces } from '../../styles';

export const StyledEditorWrapper = styled.div<{ $showBorder?: boolean; $hideBackground?: boolean }>`
  .tox-tinymce {
    border: ${({ $showBorder, theme }) => ($showBorder ? `1px solid ${theme.colors.on[100]}` : 'none')};
    border-radius: ${({ theme }) => theme.radii.xl};
  }

  // Adjust font size dropdown width to allow more
  // buttons to be visible before overflowing
  .tox button[data-mce-name='fontsize'].tox-tbtn--select {
    width: 70px !important;
  }

  .tox:not(.tox-tinymce-inline) .tox-editor-header {
    box-shadow: none;
    border-bottom: 1px solid ${({ theme }) => theme.colors.on[100]};
  }

  && .tox-edit-area__iframe {
    ${({ $hideBackground }) => $hideBackground && 'background-color: transparent;'}
  }
`;

export const editorStyles = `
  ${defaultFontFaces}
  body {
    margin: 16px 18px;
    ${baseElementStyles}
  }
  ${baseEditorStyles}
`;

export const ToolbarStyles = createGlobalStyle`
  .tox:not([dir='rtl']).tox-tinymce,
  .tox:not([dir='rtl']).tox-tinymce-aux {
    .tox-toolbar__group:not(:last-of-type) {
      border-right: 1px solid ${({ theme }) => theme.colors.on[100]};
    }
  }

// Set font size toolbar button width
.tox-tbtn.tox-tbtn--select[title^="Font size"] {
  width: 72px;
}
`;

export const StyledDisabledWrapper = styled.div`
  padding: 16px 18px;
  &:empty {
    padding: 0;
  }
  background-color: #f2f4f8;
`;

export const StyledEditorLoadingState = styled.div`
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
